const NAME = 'DOCUMENT-INSTANCE';

// Handling of requests to /documents endpoint
export const REQUEST_DOCUMENT_DETAILS = `${NAME}/REQUEST_DOCUMENT_DETAILS`;
export const REQUEST_DOCUMENT_DETAILS_SUCCESS = `${NAME}/REQUEST_DOCUMENT_DETAILS_SUCCESS`;
export const REQUEST_DOCUMENT_DETAILS_FAIL = `${NAME}/REQUEST_DOCUMENT_DETAILS_FAIL`;

export const RESET_STATE = `${NAME}/RESET_STATE`;
